/** @jsx jsx */
import { Box, Button, Text, jsx } from "theme-ui"
import { useSpring, animated as a, config } from "react-spring"
import CloseIcon from "@material-ui/icons/Close"

const styles = {
  container: {
    width: "100vw",
    height: "30px",
    cursor: "default",
    fontSize: ["10px", "16px"],
    overflow: "hidden",
    overflowX: "scroll",
    position: "fixed",
    transform: [
      "translateX(-8px)",
      "translateX(-8px)",
      "translateX(-8px)",
      "translateX(-20px)",
    ],
    textTransform: "uppercase",
    justifyContent: "space-between",
    display: "flex",
    mixBlendMode: "difference",
    color: "#000",
    backgroundColor: "#FFF",
    alignItems: "center",
    padding: ["0 8px", "0 8px", "0 8px", "0 20px"],
    p: {
      marginRight: "2em",
      display: "inline",
      whiteSpace: "nowrap",
    },
    a: {
      color: "#000",
      cursor: "pointer",
    },
  },
  button: {
    color: "#000",
    padding: "2px",
    background: "transparent",
    margin: "0px",
  },
}

function SiteCredit({ isSiteCreditOpen, toggleSiteCredit }) {
  const spring = useSpring({
    config: config.stiff,
    bottom: isSiteCreditOpen ? 0 : -30,
  })

  return (
    <a.aside
      aria-hidden={!isSiteCreditOpen}
      style={spring}
      sx={styles.container}
    >
      <Box sx={{ overflowX: "scroll" }}>
        <Text as="p" variant="secondary">
          creative direction & design:{" "}
          <a
            href="https://www.alright.studio/"
            alt="Alright Studio"
            target="_blank"
            rel="noopener noreferrer"
          >
            alright studio
          </a>
        </Text>
        <Text as="p" variant="secondary">
          development by:{" "}
          <a
            href="https://www.avc.dev/"
            alt="jarmaa studio"
            target="_blank"
            rel="noopener noreferrer"
          >
            aaron cohen
          </a>
        </Text>
        <Text as="p" variant="secondary">
          photography by:{" "}
          <a
            href="http://ianloringshiver.com/"
            alt="ian shiver"
            target="_blank"
            rel="noopener noreferrer"
          >
            ian shiver
          </a>
        </Text>
      </Box>
      <Button sx={styles.button} onClick={() => toggleSiteCredit()}>
        <CloseIcon />
      </Button>
    </a.aside>
  )
}

export default SiteCredit
